import { createSelector } from '@reduxjs/toolkit';
import { selectClientState } from '../../store/selectors';

export const selectDetails = createSelector(selectClientState, (client) => client.details);
export const selectAddresses = createSelector(selectDetails, (details) => details.addresses);
export const selectContactRoles = createSelector(selectDetails, (details) => details.accounts.contactRoles);
